module.exports = __webpack_public_path__ + "static/media/YF96_1.a04e5887.jpg";